
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from 'react-router-dom';

import MainLayout from "../layouts/MainLayout";
import PageTitle from '../components/UtilityHelpers/PageTitle';
import { useUtils } from '../hooks/useUtils';

import { useLoader } from "../hooks/useLoader";
import { useAuth } from "../hooks/useAuth";
import { useGetRequestDetailsByID } from "../hooks/Request/useGetRequestDetailsByID";
import { useGetItemsByRequestID } from '../hooks/RequestItems/useGetItemsByRequestID';

import Comments from "../components/Comments/Comments";

import ViewMembersField from "../components/ViewFields/ViewMembersField";
import ViewTextField from "../components/ViewFields/ViewTextField";
import ViewItemField from "../components/ViewFields/ViewItemField";
import StatusLabel from "../components/UtilityHelpers/StatusLabel";

const ViewRequest = () => {
    const [searchParams] = useSearchParams();
    const [dataRequest, setDataRequest] = useState({ status: "", category: "", category_type: "", is_health_safety_risk: "", health_safety_details: "", title: "", description: "", items: [], members: [], total_cost: 0 });
    const [totalCost, setTotalCost] = useState(0);
    const [requestStatus, setRequestStatus] = useState(""); 
    const helperUtils = useUtils();    

    const requestIDFromParam = searchParams.get("id");
    const request_id_from_param: number = requestIDFromParam !== null && requestIDFromParam !== undefined ? parseInt(requestIDFromParam) : 0;

    const loader = useLoader();
    const auth = useAuth();
    const navigate = useNavigate();

    const { fetchRequestsDetailsByID } = useGetRequestDetailsByID(request_id_from_param);
    const { itemsByRequestID, setItemsByRequestID, fetchItems } = useGetItemsByRequestID(request_id_from_param);

    let numCount = 1;

    const computeTotalCost = () => {
        const totalPriceTemp = itemsByRequestID.reduce((acc: any, currentItem: any) => { 
            const gst = (currentItem.currency == "NZD") ? 1 : 1;

            const totalAmount = acc + (currentItem.price_nzd * gst);

            return totalAmount;
        }, 0);
        setTotalCost(totalPriceTemp)
    }

    useEffect(() => {
        if (itemsByRequestID) {
            computeTotalCost();
        }
    }, [itemsByRequestID]);
    useEffect(() => {

        const loadData = async () => {
            try {
                loader?.setIsLoading(true);
                const requestData = await fetchRequestsDetailsByID();
                setDataRequest(requestData);
                const itemsDO = await fetchItems();
                setRequestStatus(requestData.status);
            } catch (error) {
                console.error(error);
            } finally {
                loader?.setIsLoading(false);
            }
        }

        loadData();

    }, []);
    return (
        <>
            <PageTitle title="OPS | New Request" />
            <MainLayout>
                <div className="col-span-12 rounded-sm border border-stroke bg-white px-5 pt-7.5 pb-5 shadow-default dark:border-strokedark dark:bg-boxdark sm:px-7.5 ">
                    <h5 className="text-xl font-semibold text-black dark:text-white mb-5">
                        Request Details
                    </h5>
                    <div className="relative z-0 w-full mb-5 group">
                            <div className="flex flex-row">
                                <div className="mr-2">
                                    Status : 
                                </div>
                                <div>
                                    <StatusLabel statusLabel={requestStatus} />        
                                </div>
                            </div>
                    </div>                    
                    <Comments requestID={request_id_from_param} />
                    <div>
                        <ViewMembersField
                            itemNumber={numCount}
                            labelName='List of Names.'
                            requestMember={dataRequest?.members}
                        />
                    </div>
                    <div>
                        <ViewTextField
                            itemNumber={numCount = numCount + 1}
                            labelName='Request Type'
                            value={dataRequest.category_type}
                        />
                    </div>
                    <div>
                        <ViewTextField
                            itemNumber={numCount = numCount + 1}
                            labelName='Request Category'
                            value={dataRequest.category}
                        />
                    </div>
                    <div>
                        <ViewTextField
                            itemNumber={numCount = numCount + 1}
                            labelName='Title'
                            value={dataRequest.title}
                        />
                    </div>
                    <div>
                        <ViewTextField
                            itemNumber={numCount = numCount + 1}
                            labelName='Description'
                            value={dataRequest.description}
                        />
                    </div>
                    <div>
                        <ViewItemField
                            itemNumber={numCount = numCount + 1}
                            labelName='Itemized list of parts with specifications or model numbers requested. Maximum OPEX cost for each IT part is NZ$1000 ex. GST or NZ$5000 ex. GST for each NON-IT part.'
                            requestItem={dataRequest.items}
                        />
                    </div>
                    <div>
                        <ViewTextField
                            itemNumber={numCount = numCount + 1}
                            labelName='Are the items requested in any way restricted by law or (University) rules and regulations? Do they pose any health, safety or wellbeing (HSW) risks? If yes, please explain in detail how these issues will be addressed and by whom?'
                            value={dataRequest.is_health_safety_risk}
                        />
                    </div>
                    <div>
                        <ViewTextField
                            itemNumber={numCount = numCount + 1}
                            labelName='Health & Safety Details'
                            value={dataRequest.health_safety_details}
                        />
                    </div>                       
                    <div>
                        <ViewTextField
                            itemNumber={numCount = numCount + 1}
                            labelName='Total cost in NZD calculated from the above items.'
                            value={helperUtils.convertToMoney(totalCost) + " NZD"}
                        />
                    </div>
                </div>
            </MainLayout>
        </>
    )
}

export default ViewRequest;